import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { getApiCall, postApiCall } from "../../service/httpCall";
import { API_PROMPT_ACTIVE_LIST } from "../../service/url";
import { PROMPT_STATUS, USER_ROLES } from "../../utilities/constant";
import Loader from "../../components/partials/components/loader";
import { toast } from "react-toastify";
import { InputText } from "primereact/inputtext";
import { FaPlay, FaCheck, FaTimes, FaDownload } from "react-icons/fa";
import AsyncStorage from "@react-native-async-storage/async-storage";

const PendingPromptsTable = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [audioUrl, setAudioUrl] = useState("");
  const [showAudio, setShowAudio] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);
  
  useEffect(() => {
    async function checkUserRole() {
      const rawUser = await AsyncStorage.getItem("user");
      if (!rawUser) {
        console.error("User not found in AsyncStorage");
        return null; // or handle as needed
      }
    
      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in user from AsyncStorage", e);
        return null;
      }
      if (user.role) {
        setLoggedInUserRole(user.role);
      }
    }
    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole == USER_ROLES.CALL_CENTRE_AGENT) {
      return;
    }
    fetchPrompts();
  }, [loggedInUserRole]);

  const fetchPrompts = () => {
    setLoading(true);

    // you said you will manage query param
    getApiCall(`${API_PROMPT_ACTIVE_LIST}?prompt_status=0`)
      .then((resp) => {
        const updated = resp.map((item, index) => ({
          ...item,
          key: index + 1,
          status: "Pending",
        }));

        setPrompts(updated);
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  };

  const openConfirm = (id, type) => {
    setSelectedId(id);
    setActionType(type);
    setConfirmVisible(true);
  };

  const handleConfirm = () => {
    if (!selectedId) return;

    const payload =
      actionType === "approve"
        ? { status: PROMPT_STATUS.APPROVED }
        : { status: PROMPT_STATUS.REJECT };

    postApiCall(`/v2/prompt/${selectedId}`, payload)
      .then(() => {
        if (actionType === "approve") {
          toast.success("Prompt Approved");
        } else {
          toast.warning("Prompt Rejected");
        }

        setPrompts((prev) => prev.filter((p) => p.id !== selectedId));
      })
      .catch((err) => toast.error(err))
      .finally(() => {
        setConfirmVisible(false);
        setSelectedId(null);
        setActionType("");
      });
  };

  const handleApprove = (id) => {
    const payload = { status: PROMPT_STATUS.APPROVED };

    postApiCall(`/v2/prompt/${id}`, payload)
      .then(() => {
        toast.success("Prompt Approved");

        setPrompts((prev) => prev.filter((p) => p.id !== id));
      })
      .catch((err) => toast.error(err));
  };

  const handleReject = (id) => {
    const payload = { status: PROMPT_STATUS.REJECT };

    postApiCall(`/v2/prompt/${id}`, payload)
      .then(() => {
        toast.warning("Prompt Rejected");

        setPrompts((prev) => prev.filter((p) => p.id !== id));
      })
      .catch((err) => toast.error(err));
  };

  const handleListen = (url) => {
    setAudioUrl(url);
    setShowAudio(true);
  };

  const actionTemplate = (row) => {
    return (
      <div className="d-flex gap-1">
        <Button
          className="p-button-rounded p-button-sm"
          tooltip="Listen"
          tooltipOptions={{ position: "top" }}
          onClick={() => handleListen(row.prompt_url)}
          style={{
            backgroundColor: "#0d6efd",
            border: "none",
            fontSize: "12px",
          }}
        >
          Listen
        </Button>

        <Button
          className="p-button-rounded p-button-sm"
          tooltip="Approve"
          tooltipOptions={{ position: "top" }}
          onClick={() => openConfirm(row.id, "approve")}
          style={{
            backgroundColor: "#198754",
            border: "none",
            fontSize: "12px",
          }}
        >
          Approve
        </Button>

        <Button
          className="p-button-rounded p-button-sm"
          tooltip="Reject"
          tooltipOptions={{ position: "top" }}
          onClick={() => openConfirm(row.id, "reject")}
          style={{
            backgroundColor: "#dc3545",
            border: "none",
            fontSize: "12px",
          }}
        >
          Reject
        </Button>
      </div>
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h5>Pending Prompts</h5>
        </div>

        <div className="card-body">
          <div className="d-flex justify-content-between mb-3">
            <span className="">
              <InputText
                value={globalFilter}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Search prompts..."
              />
            </span>
          </div>
          <DataTable
            value={prompts}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            globalFilter={globalFilter}
          >
            <Column field="prompt_name" header="Name" sortable />
            <Column field="prompt_duration" header="Duration" sortable />
            <Column field="prompt_category" header="Category" sortable />
            <Column field="creator.name" header="Created By" sortable />

            <Column
              header="Actions"
              body={actionTemplate}
              style={{ width: "10rem" }}
            />
          </DataTable>
        </div>
      </div>

      <Dialog
        header="Audio Playback"
        visible={showAudio}
        style={{ width: "35vw" }}
        onHide={() => setShowAudio(false)}
      >
        <audio controls style={{ width: "100%" }}>
          <source src={audioUrl} type="audio/mpeg" />
        </audio>
      </Dialog>
      <Dialog
        header="Confirm Action"
        visible={confirmVisible}
        style={{ width: "30vw" }}
        onHide={() => setConfirmVisible(false)}
        footer={
          <div>
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => setConfirmVisible(false)}
            />
            <Button
              label="Confirm"
              onClick={handleConfirm}
              style={{
                backgroundColor:
                  actionType === "approve" ? "#198754" : "#dc3545",
                border: "none",
              }}
            />
          </div>
        }
      >
        <p>
          Are you sure you want to{" "}
          <strong>{actionType === "approve" ? "approve" : "reject"}</strong>{" "}
          this prompt?
        </p>
      </Dialog>
    </>
  );
};

export default PendingPromptsTable;
